import { useMediaQuery } from '@uidotdev/usehooks';

/** True when the user asks for reduced motion, so callers can skip an exit animation's delay. */
export const useReducedMotion = (): boolean => useMediaQuery('(prefers-reduced-motion: reduce)');
